(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
class BlogLoadMore extends HTMLElement {
  connectedCallback() {
    this.action = this.querySelector('.blog-load-more__action');
    this.button = this.querySelector('button');
    this.pagination = this.querySelector('.pagination');
    if (!this.button) return;

    // JS が動く環境でだけページャを「もっと見る」に差し替える (JS 無効なら従来のページャが残る)
    if (this.pagination) this.pagination.hidden = true;
    this.action.hidden = false;

    this.button.addEventListener('click', () => this.#loadNext());
  }

  async #loadNext() {
    const nextUrl = this.getAttribute('next-url');
    if (!nextUrl || this.hasAttribute('loading')) return;

    this.setAttribute('loading', '');
    this.button.setAttribute('aria-busy', 'true');

    try {
      const separator = nextUrl.includes('?') ? '&' : '?';
      const url = `${nextUrl}${separator}section_id=${this.getAttribute('section-id')}`;
      const response = await fetch(url);

      if (!response.ok) throw new Error(`Failed to load ${url}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const currentList = this.closest('.shopify-section')?.querySelector('blog-posts');
      const nextList = doc.querySelector('blog-posts');
      if (!currentList || !nextList) throw new Error('Could not find the blog post list');

      // append で移動してしまう前に、追加分の先頭を控えておく (フォーカス移動用)
      const appended = Array.from(nextList.children);
      currentList.append(...appended);

      const nextPageUrl = doc.querySelector('blog-load-more')?.getAttribute('next-url');

      if (nextPageUrl) {
        this.setAttribute('next-url', nextPageUrl);
      } else {
        // 最終ページまで読み込んだのでボタンとページャを撤去する
        this.removeAttribute('next-url');
        this.remove();
      }

      // 追加した最初の記事にフォーカスを移し、キーボード操作でも続きから辿れるようにする
      appended[0]?.querySelector('a')?.focus();
    } catch (error) {
      console.error(error);

      // 読み込みに失敗したら、確実に遷移できるページャに戻す
      if (this.pagination) this.pagination.hidden = false;
      if (this.action) this.action.hidden = true;
    } finally {
      this.removeAttribute('loading');
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('blog-load-more')) {
  customElements.define('blog-load-more', BlogLoadMore);
}

  } catch(e) { console.error(e); }
})();
})();
